import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalConstants } from 'functions/src/shared/global-constants';
import { MainsComponent } from 'src/common/pages/mains/mains.component';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { SelectService } from 'src/common/services/select/select.service';
import { SettingService } from 'src/common/services/setting/setting.service';
import { Action } from 'src/services/action/action.model';
import { ActionPipeService } from 'src/services/action/action.service';

@Component({
  selector: 'app-pipe',
  templateUrl: './pipe.component.html',
  styleUrls: ['./pipe.component.scss']
})
export class PipeComponent extends MainsComponent {

  // public newRequests: ActionService = null;
  public actionItem = new Action(null, this.setting);
  public GLOBAL = new GlobalConstants();

  // public preview: any = null;

  constructor(
    protected afs: AngularFirestore,
    public db: ActionPipeService,
    public settings: SettingService,
    public backURL: BackurlService,
    protected router: Router,
    public setting: SettingService,
    public select: SelectService,
    protected fb: FormBuilder,
  ) {
    super(setting, db, select, router, fb, backURL);

    this.sortServerForm = this.fb.group({
      agency: [],
      realtor: [],
      arrayFilters: this.fb.group({
        agencies: [this.db.selectAgencyFilter()],
      }),
      filters: this.fb.group({
        done: [false],
      }),
    });

    this.sortLocalForm = this.fb.group({
      arrayFilters: this.fb.group({
        realtors: [this.db.selectRealtorFilter()],
      }),
    });
  }


  // changeTime($event: any) {
  //   this.sortLocalForm.get('filters.time').setValue($event.value);
  //   this.db.setLocalFilter(this.sortLocalForm.value);
  //   this.db.refreshActionTypes(this.sortLocalForm.value.filters.time);
  //   if (!this.db.actionTypes[this.sortLocalForm.value.filters.type]) {
  //     this.changeType('');
  //   }
  // }

  // changeType($event: any) {
  //   this.sortLocalForm.get('filters.type').setValue($event.value);
  //   this.db.setLocalFilter(this.sortLocalForm.value);
  // }


  calculTotal(element: any, displayCy: boolean = false): number {
    let total = 0;

    if (element.type === 'payment') {
      return element.amount;
    }

    if (this.sortLocalForm.value.arrayFilters.realtors) {
      if (element.mandate.realtor === this.sortLocalForm.value.arrayFilters.realtors) {
        total = total + element.mandateCA;
      }
      if (element.project.realtor === this.sortLocalForm.value.arrayFilters.realtors) {
        total = total + element.projectCA;
      }
    }
    else if (this.sortServerForm.value.arrayFilters.agencies) {
      if (element.mandate.agency === this.sortServerForm.value.arrayFilters.agencies) {
        total = total + element.mandateCA;
      }
      if (element.project.agency === this.sortServerForm.value.arrayFilters.agencies) {
        total = total + element.projectCA;
      }
    }
    else {
      total = element.mandateCA + element.projectCA;
    }
    if (displayCy && element.cy && element.cy !== 'mur') {
      total = total * this.setting.exRates[element.cy]?.mur;
    }
    return Math.round(total);
  }

  goItem(item: any) {
    this.backURL.addURL('/current-deals');
    if (item.type === 'payment') {
      this.router.navigate([`/${item.module}/${item.module === 'mandates' ? item.mandate.$key : item.project.$key}`]);
    } else {
      this.router.navigate([`/tasks/${item.$key}`]);
    }
  }


}
